import {
    GET_NETWORK_CONFIG,
    GET_NETWORK_CONFIG_SUCCESS,
    GET_NETWORK_CONFIG_FAIL,
} from '../../../constants/maintenance/alarmConfigurationConstants/networkConfigurationConstants';

/**
 * Reducer function for managing network alarm configuration state.
 *
 * This reducer handles actions related to fetching network alarm configuration.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the network alarm configuration.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const networkConfigReducer = (state = { network: {} }, action) => {
    switch (action.type) {
        case GET_NETWORK_CONFIG:
            return {
                loading: true,
            };
        case GET_NETWORK_CONFIG_SUCCESS:
            return {
                loading: false,
                network: action.payload,
            };
        case GET_NETWORK_CONFIG_FAIL:
            return {
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};
